var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qr-code-wrp"},[_c('canvas',{ref:"qrCode",staticClass:"w-full",class:{
      'mr-3': _vm.hasMarginRight,
    }})])}
var staticRenderFns = []

export { render, staticRenderFns }